import { create } from "zustand";
import { OperationQueue } from "@/utils/queue";

type FavoriteOperationStore = {
  operationQueue: OperationQueue<unknown>;
  pendingOperations: Set<string>;
  isPending: (documentId: string) => boolean;
};

const initialState = {
  operationQueue: new OperationQueue<unknown>(),
  pendingOperations: new Set<string>(),
};

const useFavoriteOperationStore = create<FavoriteOperationStore>((_, get) => ({
  ...initialState,
  isPending: (documentId: string) => get().pendingOperations.has(documentId),
}));

export default useFavoriteOperationStore;
